import { injectGlobal, css } from 'styled-components';
import lovelo from 'vendor/fonts/Lovelo.otf';
import viktor from 'vendor/fonts/Viktor.otf';
import catamaranBold from 'vendor/fonts/catamaran-extrabold-webfont.woff';
import catamaranBold2 from 'vendor/fonts/catamaran-extrabold-webfont.woff2';
import notosansBold from 'vendor/fonts/notosans-bold-webfont.woff';
import notosansBold2 from 'vendor/fonts/notosans-bold-webfont.woff2';
import notosansRegular from 'vendor/fonts/notosans-regular-webfont.woff';
import notosansRegular2 from 'vendor/fonts/notosans-regular-webfont.woff2';
import opensansextraboldwebfont from 'vendor/fonts/opensans-extrabold-webfont.woff';
import opensansextraboldwebfont2 from 'vendor/fonts/opensans-extrabold-webfont.woff2';
import { media } from 'utils/style-utils';

export const colors = {
  LIGHT_GRAY:      "#E7EBEC",
  LIGHTER_GRAY:    "#E1E7EA",
  LIGHTEST_GRAY:   "#F7F9FB",
  MEDIUM_GRAY:     "#688190",
  GRAY:            "#E4EBF0",
  BODY:            "#36474F",
  MAIN_COLOR:      "#F90085",
  BODY_BACKGROUND: "#EFF4F7",
  LIGHT_BLUE:      "#F2F8FF",
  WHITE:           "#FFFFFF",
  GREEN:           "#01FFD6",
  LIGHT_GREEN:     "#0CFF00",
  RED:             "#E50038",
  MENU:            "#131B38",
  MENU_LINK:       "#91ADBA",
  DARK:            "#183748",
  BUTTON_BG:       "linear-gradient(135deg, #DF33D2 0%, #FF406A 100%)",
  BORDER_BTN:      "#007AFF 1px solid",
  BORDER_NONE:     "none",
  LIGHT_MAIN_COLOR: "#ef9dca",

  ACTIVE_COLOR:		"#01FFD6"
};

export const wrapper = css`
    width: 940px;
    margin: 0px auto;
    ${ media.mobile_and_tablet`
      width: 100%;
    `}

    ${ media.desktop`
      max-width: calc(100% - 202px);
    `}
`;


const miniReset = css`
  * {
    box-sizing: border-box;
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;

  }

  button,
  input {
    border: 0;
    padding: 0;
    color: inherit;
    background-color: inherit;
  }

  table {
    border-collapse: collapse;
  }
`;

/* eslint no-unused-expressions: 0 */
injectGlobal`

  @font-face {
    font-family: proxima-nova;
    src: url(https://use.typekit.net/af/51a84d/00000000000000003b9b0393/27/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3) format("woff2"), url(https://use.typekit.net/af/51a84d/00000000000000003b9b0393/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3) format("woff"), url(https://use.typekit.net/af/51a84d/00000000000000003b9b0393/27/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3) format("opentype");
    font-weight: 900;
    font-style: normal;
    font-display: auto;
  }

  @font-face {
    font-family: myriad-pro;
    src: url(https://use.typekit.net/af/1b1b1e/00000000000000000001709e/27/l?subset_id=2&fvd=n7&v=3) format("woff2"), url(https://use.typekit.net/af/1b1b1e/00000000000000000001709e/27/d?subset_id=2&fvd=n7&v=3) format("woff"), url(https://use.typekit.net/af/1b1b1e/00000000000000000001709e/27/a?subset_id=2&fvd=n7&v=3) format("opentype");
    font-weight: 700;
    font-style: normal;
    font-display: auto;
  }

  @font-face {
    font-family: myriad-pro;
    src: url(https://use.typekit.net/af/cafa63/00000000000000000001709a/27/l?subset_id=2&fvd=n4&v=3) format("woff2"), url(https://use.typekit.net/af/cafa63/00000000000000000001709a/27/d?subset_id=2&fvd=n4&v=3) format("woff"), url(https://use.typekit.net/af/cafa63/00000000000000000001709a/27/a?subset_id=2&fvd=n4&v=3) format("opentype");
    font-weight: 400;
    font-style: normal;
    font-display: auto;
  }

  @font-face {
    font-family: spumante;
    src: url(https://use.typekit.net/af/1194bd/00000000000000003b9ada5b/27/l?subset_id=2&fvd=n4&v=3) format("woff2"), url(https://use.typekit.net/af/1194bd/00000000000000003b9ada5b/27/d?subset_id=2&fvd=n4&v=3) format("woff"), url(https://use.typekit.net/af/1194bd/00000000000000003b9ada5b/27/a?subset_id=2&fvd=n4&v=3) format("opentype");
    font-weight: 400;
    font-style: normal;
    font-display: auto;
  }

  @font-face {
    font-family: viktor-script;
    src: url(https://use.typekit.net/af/1b97ca/00000000000000003b9adf3a/27/l?subset_id=2&fvd=n4&v=3) format("woff2"), url(https://use.typekit.net/af/1b97ca/00000000000000003b9adf3a/27/d?subset_id=2&fvd=n4&v=3) format("woff"), url(https://use.typekit.net/af/1b97ca/00000000000000003b9adf3a/27/a?subset_id=2&fvd=n4&v=3) format("opentype");
    font-weight: 400;
    font-style: normal;
    font-display: auto;
  }

  @font-face {
    font-family: 'open_sansextrabold';
    src: url(${opensansextraboldwebfont}),
        url(${opensansextraboldwebfont2});
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Lovelo';
    font-style: normal;
    font-weight: 900;
    src: url(${lovelo});
  }

  @font-face {
    font-family: 'Viktor Script';
    font-style: normal;
    src: url(${viktor});
  }
  @font-face {
    font-family: 'catamaranextrabold';
    src: url(${catamaranBold}),
        url(${catamaranBold2});
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'notosansBold';
    src: url(${notosansBold}),
        url(${notosansBold2});
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'notosansRegular';
    src: url(${notosansRegular}),
        url(${notosansRegular2});
    font-weight: normal;
    font-style: normal;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: neue-haas-unica, sans-serif;
    font-weight: 300;
    font-size: 14px;
    color: ${colors.DARK};
    height: 100%;
    overflow: hidden;
  }

  a,
  a:visited,
  a:hover,
  a:active { color: inherit; text-decoration: none; }
  a:focus { outline: none; }

 input::-webkit-input-placeholder { color: #B9C3C8; }
 input::-moz-placeholder {color: #B9C3C8 }
 input:-ms-input-placeholder {color: #B9C3C8 }
 input:-moz-placeholder {color: #B9C3C8 }
 input:-webkit-autofill { -webkit-box-shadow: 0 0 0 1000px ${colors.WHITE} inset; }

  #root {
    min-height: 100%;
    min-width: 100%;
  }

  button {
    cursor: pointer;
    padding: 2px 6px;
    font-weight: bold;
    font-size: 12px;
    font-family: poppins, sans-serif;
    text-align: center;
  }

  button:focus { outline: none; }

  ${miniReset}
`;



// WEBPACK FOOTER //
// ./src/globalStyles.js